import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

const BAGDE_HEIGHT = 24

export const BetaTitleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`

export const BetaLabelButton = styled.button`
  display: flex;
  align-items: center;
  height: ${BAGDE_HEIGHT}px;
  margin-left: ${Spacing.S8};
  padding-right: ${Spacing.S8};
  padding-left: ${Spacing.S8};
  border: none;
  border-radius: ${BAGDE_HEIGHT / 2}px;
  background-color: ${Color.Purple200};
  cursor: pointer;
  appearance: none;
`
